//Import project dependencies

// HOW DO I GET CALLED?: see Notes/DevNotes in the solution for details


//@TODO fix
//When these are imported they are not found, because it would be nice to not have to include only minified files for source mapping....
//import './dependencies/jquery';
//import './dependencies/tether';
//When these are imported they are not found, because it would be nice to not have to include only minified files for source mapping....
//Steve used old bootstrap stuff for modals and wrapped it to get it to work in Angular.  Need to replace that so we can pull this.
import './dependencies/bootstrap';

//Polyfill for ES6 functions (decorators, promises, etc...)
import 'babel-polyfill';

import './prototypes';
import './polyfills';
import './extensions/array-extensions';
import './extensions/string-extensions';

//Angular Boilerplate
import 'zone.js/dist/zone';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

//RxJs
import 'rxjs';
//import 'rxjs/add/operator/catch';
//import 'rxjs/add/observable/throw';
//import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/publish';
//import 'rxjs/add/operator/publishLast';
//import 'rxjs/add/operator/share';
//import 'rxjs/add/operator/mergeMap';
//import 'rxjs/add/operator/delay';
//import 'rxjs/add/operator/merge';
//import 'rxjs/add/operator/switchMap';

//Config/Globals
import { appConfig } from './shared/appConfig.js';
import { Enums } from './shared/enums.js';
import { enableProdMode } from '@angular/core';

//Load AppModule
import { AppModule } from './app/app.module';


if (!appConfig.DEV_MODE){ enableProdMode(); }

platformBrowserDynamic().bootstrapModule( AppModule );
